import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './styles.module.scss';

class InputLabel extends Component {
  handleChange = (e) => {
    const { onChangeFormik, onChange } = this.props;

    onChangeFormik?.(e);
    onChange?.(e);
  };

  render() {
    const {
      actions,
      className,
      materialIcon,
      icon,
      inputClassName,
      errorClassName,
      name,
      label,
      placeholder,
      inputType,
      onFocus,
      onBlur,
      disabled,
      value,
      error,
      isFocused,
      showError,
      readOnly,
      iconClassName,
      labelClassName,
      fieldRef,
      isTextarea,
      labelContainerClassName,
      inputContainerClassName,
      autoComplete,
      onClick
    } = this.props;
    const InputComponent = isTextarea ? 'textarea' : 'input';

    return (
      <div
        className={cn('middle text-base', styles.container, className, {
          [styles.error]: error,
          [styles.focused]: isFocused,
          [errorClassName]: error,
          [styles.dirty]: value,
          row: !label,
          column: label
        })}>
        <div
          className={cn('row middle text-base', styles.labelContainer, labelContainerClassName, {
            'm-bottom-2': !!label,
            'full-width': label
          })}>
          {materialIcon?.iconName && (
            <span
              className={cn(`material-icons-${materialIcon.type}`, {
                [materialIcon.className]: materialIcon.className
              })}>
              {materialIcon.iconName}
            </span>
          )}
          {icon && <i className={`text-emperor m-right-2 ${icon} ${styles.icon} ${iconClassName}`} />}
          {label && (
            <label htmlFor={name} className={`text-emperor' ${styles.label} ${labelClassName}`}>
              {label}
            </label>
          )}
        </div>
        <div
          className={`row middle full-width text-base ${styles.inputContainer} ${inputContainerClassName}`}>
          <InputComponent
            className={cn('row middle full-width', styles.input, inputClassName, {
              [styles.noResize]: isTextarea
            })}
            name={name}
            id={name}
            type={inputType}
            placeholder={placeholder}
            onChange={this.handleChange}
            onFocus={onFocus}
            onBlur={onBlur}
            disabled={disabled}
            value={value}
            readOnly={readOnly}
            autoComplete={autoComplete}
            onClick={onClick}
            {...(fieldRef && { ref: fieldRef })}
          />
          {actions && <div className={`row ${styles.actions}`}>{actions}</div>}
        </div>
        {showError && <p className={styles.inputError}>{error}</p>}
      </div>
    );
  }
}

InputLabel.propTypes = {
  inputType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  actions: PropTypes.element,
  autoComplete: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  errorClassName: PropTypes.string,
  fieldRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  focusedClassName: PropTypes.string,
  icon: PropTypes.string,
  iconClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  inputContainerClassName: PropTypes.string,
  isFocused: PropTypes.bool,
  isTextarea: PropTypes.bool,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  labelContainerClassName: PropTypes.string,
  materialIcon: PropTypes.shape({
    className: PropTypes.string,
    iconName: PropTypes.string,
    type: PropTypes.string
  }),
  placeholder: PropTypes.string,
  placeholderClassName: PropTypes.string,
  readOnly: PropTypes.bool,
  showError: PropTypes.bool,
  styledPlaceholder: PropTypes.bool,
  textClassName: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onChangeFormik: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func
};

InputLabel.defaultProps = {
  autoComplete: true,
  className: '',
  errorClassName: '',
  focusedClassName: '',
  iconClassName: '',
  inputClassName: '',
  inputContainerClassName: '',
  labelClassName: '',
  labelContainerClassName: '',
  materialIcon: {
    type: 'outlined'
  },
  placeholder: '',
  showError: true,
  textClassName: '',
  value: ''
};

export default InputLabel;
